export const VIDEO_LIST_REQUEST = 'VIDEO_LIST_REQUEST';
export const VIDEO_LIST_SUCCESS = 'VIDEO_LIST_SUCCESS';
export const VIDEO_LIST_FAIL = 'VIDEO_LIST_FAIL';

export const VIDEO_DETAILS_REQUEST = 'VIDEO_DETAILS_REQUEST';
export const VIDEO_DETAILS_SUCCESS = 'VIDEO_DETAILS_SUCCESS';
export const VIDEO_DETAILS_FAIL = 'VIDEO_DETAILS_FAIL';

export const VIDEO_AUTOPLAY_REQUEST = 'VIDEO_AUTOPLAY_REQUEST';
export const VIDEO_AUTOPLAY_SUCCESS = 'VIDEO_AUTOPLAY_SUCCESS';
export const VIDEO_AUTOPLAY_FAIL = 'VIDEO_AUTOPLAY_FAIL';

export const VIDEO_CREATE_REQUEST = 'VIDEO_CREATE_REQUEST';
export const VIDEO_CREATE_SUCCESS = 'VIDEO_CREATE_SUCCESS';
export const VIDEO_CREATE_FAIL = 'VIDEO_CREATE_FAIL';
export const VIDEO_CREATE_RESET = 'VIDEO_CREATE_RESET';

export const VIDEO_REVIEW_CREATE_REQUEST = 'VIDEO_REVIEW_CREATE_REQUEST';
export const VIDEO_REVIEW_CREATE_SUCCESS = 'VIDEO_REVIEW_CREATE_SUCCESS';
export const VIDEO_REVIEW_CREATE_FAIL = 'VIDEO_REVIEW_CREATE_FAIL';
export const VIDEO_REVIEW_CREATE_RESET = 'VIDEO_REVIEW_CREATE_RESET';

export const VIDEO_UPDATE_REQUEST = 'VIDEO_UPDATE_REQUEST';
export const VIDEO_UPDATE_SUCCESS = 'VIDEO_UPDATE_SUCCESS';
export const VIDEO_UPDATE_FAIL = 'VIDEO_UPDATE_FAIL';
export const VIDEO_UPDATE_RESET = 'VIDEO_UPDATE_RESET';

export const VIDEO_DELETE_REQUEST = 'VIDEO_DELETE_REQUEST';
export const VIDEO_DELETE_SUCCESS = 'VIDEO_DELETE_SUCCESS';
export const VIDEO_DELETE_FAIL = 'VIDEO_DELETE_FAIL';
export const VIDEO_DELETE_RESET = 'VIDEO_DELETE_RESET';

export const VIDEO_CATEGORY_LIST_REQUEST = 'VIDEO_CATEGORY_LIST_REQUEST';
export const VIDEO_CATEGORY_LIST_SUCCESS = 'VIDEO_CATEGORY_LIST_SUCCESS';
export const VIDEO_CATEGORY_LIST_FAIL = 'VIDEO_CATEGORY_LIST_FAIL';

export const VIDEO_WATCHED_REQUEST = 'VIDEO_WATCHED_REQUEST';
export const VIDEO_WATCHED_SUCCESS = 'VIDEO_WATCHED_SUCCESS';
export const VIDEO_WATCHED_FAIL = 'VIDEO_WATCHED_FAIL';

export const VIDEO_COUNTER_REQUEST = 'VIDEO_COUNTER_REQUEST';
export const VIDEO_COUNTER_SUCCESS = 'VIDEO_COUNTER_SUCCESS';
export const VIDEO_COUNTER_FAIL = 'VIDEO_COUNTER_FAIL';